export default {
  navbarLeft: [
    {
      name: 'About',
      subLinks: [
        { name: 'Research', href: '/research' },
        { name: 'Features', href: '/features' },
        { name: 'Performance', href: '/performance' },
        { name: 'Hardware & Simulators', href: '/devices' },
        { name: 'Learn', href: '/qml' },
        { name: 'Teach', href: '/education' },
      ],
    },
    {
      name: 'Software & Documentation',
      subLinks: [
        {
          name: 'Install PennyLane',
          href: '/install',
        },
        { name: 'Documentation', href: 'https://docs.pennylane.ai/en/stable/' },
        {
          name: 'Catalyst Compilation Docs',
          href: 'https://docs.pennylane.ai/projects/catalyst/en/stable/',
        },
        {
          name: 'Development Guide',
          href: 'https://docs.pennylane.ai/en/stable/development/guide.html',
        },
        {
          name: 'How-to Demos',
          href: '/search/?contentType=DEMO&categories=how-to&sort=publication_date',
        },
        {
          name: 'API',
          href: 'https://docs.pennylane.ai/en/stable/code/qml.html',
        },
        {
          name: 'GitHub',
          href: 'https://github.com/PennyLaneAI/pennylane',
        },
      ],
    },
    {
      name: 'Resources',
      subLinks: [
        {
          name: 'Demos',
          href: '/qml/demonstrations',
        },
        {
          name: 'Quantum Compilation',
          href: '/compilation',
        },
        {
          name: 'Quantum Datasets',
          href: '/datasets',
        },
        {
          name: 'Codebook',
          href: '/codebook',
        },
        { name: 'Coding Challenges', href: '/challenges' },
        { name: 'Videos', href: '/qml/videos' },
      ],
    },
    {
      name: 'Topics',
      subLinks: [
        {
          name: 'Hamiltonian Simulation',
          href: '/topics/hamiltonian-simulation',
        },
        {
          name: 'Fault-Tolerant Quantum Computing',
          href: '/topics/fault-tolerant-quantum-computing',
        },
        {
          name: 'Quantum Gradients',
          href: '/topics/quantum-gradients',
        },
      ],
    },
    {
      name: 'Community & Support',
      subLinks: [
        {
          name: 'Blog',
          href: '/blog?page=1',
        },
        {
          name: 'FAQs',
          href: '/faq',
        },
        {
          name: 'Discussion Forum',
          href: 'https://discuss.pennylane.ai',
        },
        {
          name: 'Submit a Demo',
          href: '/qml/demos_submission',
        },
        {
          name: 'Get Involved',
          href: '/get-involved',
        },
      ],
    },
  ],
  navbarRight: {
    buttonLink: {
      text: 'Install',
      link: '/install',
    },
  },
  signInCard: {
    description:
      'Welcome to PennyLane! To make the most of your experience, sign in or create a free account with us.',
    buttonText: 'Sign in',
    createAccountText: 'Create a free account',
    bottomLinks: [
      { link: '/terms', text: 'Terms of service' },
      { link: '/privacy', text: 'Privacy policy' },
    ],
  },
  mobileButton: {
    text: 'Install',
    link: '/install',
  },
}
